export type IdentityCardDataRequestBody = {
  type: string | null;
  cardNumber: string;
  issuedOn?: string | null;
  validUntil: string | null;
  issuer: string | null;
  issuedInCountryCode: string | null;
  note: string | null;
};
